export default __webpack_public_path__ + "static/media/natural.671633c4.jpg";